import React from 'react';
import "./style.css";
const Support = () => {
    return (
        <div className='Container'>
            <h2>Suport Center</h2>
            <div className='privacy'>
                <p>Welcome to the Ganpati Traders Support Center! We're here to assist you every step of the way. Whether you have a question about your order, need help with a product, or require technical guidance, we've got you covered. Explore our comprehensive support resources below.</p>
                <h3>How Can We Help You?</h3>
                <p><strong>Frequently Asked Questions (FAQs)</strong></p>
                <p>Find quick answers to common questions:</p>
                <ul id='ulTag'>
                    <li style={{ color: '#000', fontSize: '18px' }}>
                        <strong>How do I place an order?</strong>
                    </li>
                    <li style={{ color: '#000', fontSize: '18px' }}>
                        <strong>What payment methods do you accept?</strong>
                    </li>
                    <li style={{ color: '#000', fontSize: '18px' }}>
                        <strong>How can I track my order?</strong>
                    </li>
                    <li style={{ color: '#000', fontSize: '18px' }}>
                        <strong>What is your return policy?</strong>
                    </li>
                </ul>
                <p>For more FAQs, visit our FAQ section.</p>

                <h4>Contact Us</h4>
                <p>Our support team is ready to assist you. Connect with us using any of the following methods:</p>
                <ul id='ulTag'>

                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Email:</strong> Send us a message at <a style={{ textDecoration: 'none', fontWeight: 'bold', color: 'blue' }} href='mailto:info@ganpatitraders.online'>info@ganpatitraders.online</a>
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Phone:</strong> Call us at <strong>8209393590</strong> for immediate assistance.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Live Chat:</strong> Click the chat icon on our website for instant support.
                    </li>
                </ul>
                <p>We're available <strong>from 9 AM to 7 PM, Monday to Saturday.</strong></p>
                <h4>Troubleshooting Guides</h4>
                <p>Are you having an issue? Check out our step-by-step troubleshooting articles tailored to resolve common problems:</p>


                <ul id='ulTag'>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Product Setup Help</strong>
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Order Status Not Updating</strong>
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Payment Issues</strong>
                    </li>
                </ul>


                <p>If you can't find what you're looking for, feel free to contact our support team.</p>

                <h4>Additional Resources</h4>

                <ul id='ulTag'>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Order Tracking:</strong> Use our Track My Order page to get real-time updates on your delivery.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Product Manuals:</strong> Access detailed manuals for all our products in the Product Guides section.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Returns & Refunds:</strong> Learn more about our hassle-free return and refund process here.
                    </li>
                </ul>

                <h4>Feedback & Suggestions</h4>
                <p>We value your input! If you have any suggestions or if you'd like to share your experience with us, please drop us an email at <strong style={{ textDecoration: 'none', fontWeight: 'bold', color: 'blue' }} onClick={() => window.open('mailto:info@ganpatitraders.online')}>info@ganpatitraders.online</strong>. Your feedback helps us improve and serve you better.
                    <br /><br />
                    Thank you for choosing Ganpati Traders  . We're here to make your experience smooth, convenient, and enjoyable!
                </p>

            </div>
        </div>
    )
}

export default Support;